import type { SharedUserListResponse } from '../apis/project-share-api';
import type { InviteProjectByEmailData, SharedUserListData } from '../types';

export interface ProjectShareService {
    inviteProjectByEmail(data: InviteProjectByEmailData): Promise<void>;
    getSharedUsers(data: SharedUserListData): Promise<SharedUserListResponse>;
    removeUser(projectId: string, shareId: string): Promise<void>;
}

export const ProjectShareService = Symbol('ProjectShareService');
